import { defineStore } from 'pinia'
import { api } from '@/plugins/api'

const invoiceDefault = {
  firm: null,
  invoice: null,
  createdOn: null,
  ronumber: null,
  invoiceNumber: null,
  url: null,
  name: null,
  isInactive: false,
  isChecked: false
}
export const invoiceStore = defineStore({
  id: 'invoice',
  state: () => ({
    invoices: [],
    invoice: null,
    invoiceDocs: [],
    invoicePages: [],
    renderTables: [],
    invoiceTables: [],
    loading: {
      invoices: false,
      invoice: false,
      analysis: false,
      alignment: false
    },
    listParams: {
      page: 1,
      pageSize: sessionStorage.getItem('pageSize') ? sessionStorage.getItem('pageSize') : 10,
      filterOptions: null,
      filterBy: null,
      sortBy: sessionStorage.getItem('sortBy') ? sessionStorage.getItem('sortBy') : 'asc',
      orderBy: sessionStorage.getItem('orderBy') ? sessionStorage.getItem('orderBy') : 'createdOn',
      searchTerm: ''
    },
    isChecked: false,
    analyis: null,
    firm: null,
    copiedCells: [],
    selectedCells: [],
    alignment: []
  }),
  actions: {
    setListParam(data) {
      this.listParams[data.name] = data.value
      if (data.name === 'pageSize' || data.name === 'sortBy' || data.name === 'orderBy') {
        sessionStorage.setItem(data.name, data.value)
      }
    },
    resetInvoice(firm) {
      console.log('Resetting Invoice...')
      this.invoice = JSON.parse(JSON.stringify(invoiceDefault))
      if (firm) {
        this.invoice.firm = firm
      }
      this.invoicePages = []
      this.renderTables = []
      this.invoiceTables = []
      this.copiedCells = []
      this.selectedCells = []
    },
    setInvoice(data) {
      this.invoice[data.name] = data.value
    },
    anyChecked() {
      this.isChecked = this.invoices.some((invoice) => invoice.isChecked)
    },
    resetCells() {
      this.copiedCells = []
      this.selectedCells = []
    },
    cellAction(data) {
      switch (data.name) {
        case 'copy': {
          let found = this.copiedCells.find((cell) => cell.page === data.page && cell.idx === data.idx && cell.data === data.value)
          if (found) {
            this.copiedCells = this.copiedCells.filter((cell) => !(cell.page === data.page && cell.idx === data.idx && cell.data === data.value))
          } else {
            this.copiedCells.push({
              page: data.page,
              data: data.value,
              idx: data.idx
            })
          }
          // console.log('Copied Cells', this.copiedCells)
          break
        }
        case 'select': {
          let found = this.selectedCells.find((cell) => cell.page === data.page && cell.idx === data.idx && cell.key === data.key)
          if (found) {
            this.selectedCells = this.selectedCells.filter((cell) => !(cell.page === data.page && cell.idx === data.idx && cell.key === data.key))
          } else {
            this.selectedCells.push({
              page: data.page,
              data: data.value,
              idx: data.idx,
              key: data.key
            })
          }
          // console.log('Selected Cells', this.selectedCells)
          break
        }
        case 'total': {
          if (this.selectedCells.length === 0) {
            this.selectedCells.push({
              page: data.page,
              data: data.value.toFixed(2),
              idx: data.idx,
              key: data.key
            })
          } else {
            let found = this.selectedCells.find((cell) => cell.page === data.page)
            if (found) {
              let total = parseFloat(found.data) + parseFloat(data.value)
              found.data = total.toFixed(2)
            }
          }
        }
      }
    },
    async getInvoices(data) {
      this.invoices = []
      this.loading.invoices = true
      let results = await api.get(
        `invoice/invoices?firm=${data.firm}&searchTerm=${data.searchTerm}&offset=${data.offset}&pageSize=${data.pageSize}&orderBy=${data.orderBy}&sortBy=${data.sortBy}&status=${data.status}&filter=${data.filter}`
      )
      if (results) {
        this.invoices = {
          count: results[0].totalItems,
          items: results
        }
        this.invoices.items.forEach((element) => {
          element.isChecked = false
        })
      }
      this.loading.invoices = false
      console.log('Got Invoices', this.invoices)
      return this.invoices
    },
    async getInvoice(invoice) {
      this.invoice = null
      this.loading.invoice = true
      let results = await api.get(`invoice/invoice?invoice=${invoice}`)
      if (results) {
        this.invoice = results
        if (this.invoice.analysis) {
          this.invoice.analysis = JSON.parse(this.invoice.analysis)
          console.log('Got Invoice', this.invoice)
          var pages = this.invoice.analysis.Value.Pages
          var tables = this.invoice.analysis.Value.Tables
          this.invoiceDocs = this.invoice.analysis.Value.Documents
          this.invoicePages = []
          this.renderTables = []
          this.invoiceTables = []
          this.alignment = []
          if (this.invoice.alignment) {
            this.alignment = JSON.parse(this.invoice.alignment)
          }
          for (var i = 0; i < tables.length; i++) {
            var temp = tables[i].Cells.filter((item) => item.Content && item.Content.trim() !== '') // Remove empty content
              .map(({ RowIndex, ColumnIndex, Content }) => ({
                RowIndex,
                ColumnIndex,
                Content: Content.replace(/\n/g, ' ') // Replace newlines with spaces for cleaner display
              }))
            this.invoiceTables.push(temp)
            temp = tables[i].BoundingRegions.map(({ PageNumber, Polygon }) => ({
              index: i,
              page: PageNumber,
              polygon: Polygon
            }))
            this.renderTables.push(temp)
          }
          this.renderTables = this.renderTables.flat()
          console.log('Invoice Documents', this.invoiceDocs)
          console.log('Invoice Tables', this.invoiceTables)
          console.log('Render Tables', this.renderTables)
          this.invoicePages = pages.map((page) => ({
            pageNumber: page.PageNumber,
            height: page.Height,
            width: page.Width,
            words: page.Words.map((word) => ({
              content: word.Content,
              polygon: word.Polygon
            }))
          }))
          console.log('Invoice Pages', this.invoicePages)
          if (
            this.invoice.vendorName === null ||
            this.invoice.vendorName === '' ||
            this.invoice.invoiceNumber === null ||
            this.invoice.invoiceNumber === ''
          ) {
            if (this.invoiceDocs) {
              if (this.invoiceDocs.length > 0) {
                let vendorName = this.invoiceDocs[0].Fields.VendorName ? this.invoiceDocs[0].Fields.VendorName.Content : ''
                let invoiceId = this.invoiceDocs[0].Fields.InvoiceId ? this.invoiceDocs[0].Fields.InvoiceId.Content : ''
                let data = {
                  firm: this.invoice.firm,
                  invoice: this.invoice.invoice,
                  vendorName: vendorName,
                  invoiceNumber: invoiceId.toString()
                }
                console.log('Updating Invoice with Vendor/Invoice', data)
                await this.updateInvoice(data)
              }
            }
          }
        }
      }
      this.loading.invoice = false
      return this.invoice
    },
    deleteInvoice(id) {
      return api.delete(`invoice/invoice?invoice=${id}`)
    },
    deleteInvoices() {},
    analyze(url) {
      return api.post('invoice/analyze', {
        url: url
      })
    },
    async analyzeInvoice(data) {
      this.loading.analysis = true
      let results = await api.post('invoice/analyze', data)
      this.loading.analysis = false
      return results
    },
    async saveStatus(data) {
      return api.post('invoice/status', data)
    },
    async updateInvoice(data) {
      return api.post('invoice/update', data)
    },
    async alignAutofill(data) {
      this.loading.alignment = true
      this.alignment = []
      let results = await api.post('invoice/alignAutofill', data)
      if (results) {
        this.alignment = results
      }
      this.loading.alignment = false
      console.log('Alignment', this.alignment)
      return this.alignment
    }
  }
})
